// Enlaces del Navbar. Para agregar una página visible, añade un item aquí
// y declara su <Route> en app/routes/App.routes.tsx

import { NavItem } from 'types';

export const NAV_ITEMS: NavItem[] = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/resume', label: 'Resume' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/certificates', label: 'Certificates' },
    // { path: '/contact', label: 'Contact' },
];
